import { render, staticRenderFns } from "./dialogList.vue?vue&type=template&id=409bb0d1&scoped=true&"
import script from "./dialogList.vue?vue&type=script&lang=ts&"
export * from "./dialogList.vue?vue&type=script&lang=ts&"
import style0 from "./dialogList.vue?vue&type=style&index=0&id=409bb0d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bb0d1",
  null
  
)

export default component.exports